export default "__VITE_ASSET__BxqGm6pv__"